<div class="course-layout-wrapper ms-3">
  <div class="course-sidebar" *ngIf="showSidebar">
    <div class="sidebar-header mt-2 mb-3">
      <i class="bi bi-arrow-left-short" (click)="goBack()"></i>
      <span class="ms-2"> Course Setup </span>
    </div>


    <ul class="step-list">
      <li>
        <a class="step nav-link" routerLink="course-creation-form" routerLinkActive="active">
          <span class="step-icon">1</span>
          <span class="step-label">Course Details</span>
        </a>
      </li>
      <li>
        <a class="step nav-link" routerLink="objective" routerLinkActive="active">
          <span class="step-icon">2</span>
          <span class="step-label">Course Objective</span>
        </a>
      </li>
      <li>
        <a class="step nav-link" routerLink="add-units" routerLinkActive="active">
          <span class="step-icon">3</span>
          <span class="step-label">Add Units</span>
        </a>
      </li>
      <li>
        <a class="step nav-link" routerLink="course-outcome" routerLinkActive="active">
          <span class="step-icon">4</span>
          <span class="step-label">Course Outcome</span>
        </a>
      </li>
      <li>
        <a class="step nav-link" routerLink="add-resources" routerLinkActive="active">
          <span class="step-icon">5</span>
          <span class="step-label">Add Resources</span>
        </a>
      </li>
    </ul>

    <div class="sidebar-footer">
      <img src="assets/images/navbar-image.png" class="img-fluid" alt="reset-image" />
    </div>
  </div>

  <div class="course-main-content">
    <router-outlet></router-outlet>
  </div>
</div>